import getApiInstance from 'data/common/ApiCallGenerique';
/** @var Logger Logger */
import Logger from 'data/common/Logger';
import api from './api';
/** @var ApiCall apiCaller */

const apiCaller = getApiInstance('gitlab');

function getLabels() {
    return (dispatch, getState) => {
        return apiCaller
            .call(api.getLabels())
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.error('dataActions: getLabels - ', error);
                throw error;
            });
    };
}

export { getLabels };



// WEBPACK FOOTER //
// ./environments/genericEnv/data/Labels/actions.js